var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6193 17.2073C24.71 17.9233 24.66 19.5835 23.4693 20.213L15.0906 24.6419C14.4084 25.0025 13.5921 25.0025 12.9098 24.6419L4.53115 20.213C3.3405 19.5835 3.29044 17.9234 4.38097 17.2073L4.45437 17.253L12.9097 21.7248C13.5919 22.0855 14.4084 22.0855 15.0905 21.7248L23.4692 17.2959C23.5214 17.2683 23.5715 17.2387 23.6193 17.2073ZM23.6193 12.5406C24.6626 13.2255 24.6622 14.7743 23.6181 15.4585L23.4693 15.5463L15.0906 19.9752C14.4704 20.303 13.7394 20.3328 13.099 20.0646L12.9098 19.9752L4.53115 15.5463C3.3405 14.9169 3.29044 13.2567 4.38097 12.5406L4.45437 12.5863L12.9097 17.0582C13.5299 17.386 14.261 17.4158 14.9014 17.1476L15.0905 17.0582L23.4692 12.6293C23.5214 12.6016 23.5715 12.572 23.6193 12.5406ZM15.0905 3.3564L23.4692 7.78532C24.7121 8.44232 24.7121 10.2226 23.4692 10.8796L15.0905 15.3085C14.4084 15.6691 13.5919 15.6691 12.9097 15.3085L4.53106 10.8796C3.28815 10.2226 3.28815 8.44232 4.53106 7.78532L12.9097 3.3564C13.5919 2.99578 14.4084 2.99578 15.0905 3.3564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionIcon);
export default __webpack_public_path__ + "static/media/version_icon.009f8106412cbe175d6deaf28fc94f6f.svg";
export { ForwardRef as ReactComponent };